function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { isFieldPath } from "../../fieldPath";
import { FormPath } from "@formily/core";
export class PathTool {
  static toNoVoidStringPath(path) {
    if (isFieldPath(path)) {
      return path.noVoidPath();
    }
    return path;
  }
  static collectExactPaths(path, data) {
    const exactPaths = [];
    this._traverseArrayPath("", [], path, data, (exactPath) => exactPaths.push(exactPath));
    return exactPaths;
  }
  static toExactPath(path, indices) {
    const paths = path.split(this.ARRAY_WILD_CARD);
    let exactPath = "";
    for (let i = 0; i < paths.length; i++) {
      exactPath += `${paths[i]}`;
      if (i < paths.length - 1) {
        var _indices_i;
        const index = (_indices_i = indices[i]) !== null && _indices_i !== void 0 ? _indices_i : 0;
        exactPath += `.${index}.`;
      }
    }
    return exactPath;
  }
  static isArrayPath(path) {
    return this.toNoVoidStringPath(path).includes(this.ARRAY_WILD_CARD);
  }
  static _traverseArrayPath(parentPath, parentIndices, currentPath, data, executor) {
    if (!this._isArrayPath(currentPath)) {
      if (parentPath) {
        executor({
          path: `${parentPath}${currentPath}`,
          indices: parentIndices
        });
      }
      return;
    }
    const { parent, child } = this._seperateTopParent(currentPath);
    const array = FormPath.getIn(data, parent);
    if (!Array.isArray(array)) {
      return;
    }
    array.forEach((item, index) => {
      const newParentPath = `${parentPath}${parent}.${index}.`;
      const newParentIndices = [
        ...parentIndices,
        index
      ];
      this._traverseArrayPath(newParentPath, newParentIndices, child, item, executor);
    });
  }
  static _isArrayPath(path) {
    return path.includes(this.ARRAY_WILD_CARD);
  }
  static _seperateTopParent(arrayPath) {
    const [parent, ...childs] = arrayPath.split(this.ARRAY_WILD_CARD);
    const childPath = childs.join(this.ARRAY_WILD_CARD);
    return {
      parent,
      child: childPath
    };
  }
}
_define_property(PathTool, "ARRAY_WILD_CARD", ".*.");
